import React from 'react';
import { Icon, Divider } from 'antd';
import moment from 'moment';

var MONTH_NAMES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

var formatBRL = function(v) {
  var n = Number(v) || 0;
  return 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

var formatDateBR = function(raw) {
  if (!raw) return '—';
  var d = moment(String(raw).substr(0, 10), 'YYYY-MM-DD');
  return d.isValid() ? d.format('DD/MM/YYYY') : String(raw);
};

var Row = function(props) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0', fontWeight: props.strong ? 600 : 400 }}>
      <span style={{ color: '#595959' }}>{props.label}</span>
      <span style={{ color: '#262626' }}>{props.value}</span>
    </div>
  );
};

var Breakdown13Content = function(props) {
  var b = props.breakdown;
  var stored = props.stored;
  if (!b) return null;

  var monthsLabel = (b.months_list && b.months_list.length > 0)
    ? b.months_list.map(function(m) { return MONTH_NAMES[m - 1]; }).join(', ')
    : 'nenhum';

  var calculated = b.installment_amount;
  var drifted = Math.abs(Number(stored || 0) - Number(calculated || 0)) > 0.01;

  return (
    <div style={{ width: 320, fontSize: 13, lineHeight: 1.5 }}>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>
        <Icon type="calculator" style={{ marginRight: 6 }} />
        Cálculo proporcional do 13º
      </div>

      <Row label="Base mensal" value={formatBRL(b.base_amount)} />
      <Row label="Meses válidos (≥15 dias)" value={b.months_worked + ' de 12'} />

      <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 2, marginBottom: 8 }}>
        {monthsLabel}
      </div>

      <Divider style={{ margin: '6px 0' }} />

      <Row label="13º anual" value={formatBRL(b.annual_13)} />
      <Row label="Parcelas no ano" value={b.split_total + 'x'} />
      <Row label="Valor desta parcela" value={formatBRL(calculated)} strong />

      <Divider style={{ margin: '8px 0' }} />

      <div style={{ fontSize: 11, color: '#8c8c8c' }}>
        <div><strong>Período considerado</strong></div>
        <div>De {formatDateBR(b.effective_start)} a {formatDateBR(b.effective_end)}</div>
        {b.raw_start ? (
          <div style={{ marginTop: 4 }}>Início do cliente: {formatDateBR(b.raw_start)}</div>
        ) : null}
        {b.raw_end ? (
          <div>Fim do cliente: {formatDateBR(b.raw_end)}</div>
        ) : null}
      </div>

      {b.is_partial ? (
        <div style={{ marginTop: 10, padding: '6px 8px', background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 4, fontSize: 11, color: '#ad6800' }}>
          <Icon type="info-circle" style={{ marginRight: 4 }} />
          Valor proporcional — cliente ativo por {b.months_worked} de 12 meses no ano.
        </div>
      ) : null}

      {drifted ? (
        <div style={{ marginTop: 8, padding: '6px 8px', background: '#fff1f0', border: '1px solid #ffa39e', borderRadius: 4, fontSize: 11, color: '#a8071a' }}>
          <Icon type="warning" style={{ marginRight: 4 }} />
          Valor armazenado ({formatBRL(stored)}) diverge do cálculo atual. Regere as mensalidades para atualizar.
        </div>
      ) : null}
    </div>
  );
};

export default Breakdown13Content;
